var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { notifyRequestError, notifyRequestStart, notifyRequestSuccess } from './utils';
var Http = /** @class */ (function () {
    function Http(config) {
        this.baseUrl = config.baseUrl;
    }
    Http.buildResponse = function (data) {
        return data;
    };
    Http.buildError = function (response, error) {
        var _a, _b, _c;
        return {
            status: response.status,
            code: (_a = error === null || error === void 0 ? void 0 : error.code) !== null && _a !== void 0 ? _a : null,
            message: (_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : null,
            errors: (_c = error === null || error === void 0 ? void 0 : error.errors) !== null && _c !== void 0 ? _c : undefined,
        };
    };
    Http.getDDSessionId = function () {
        var _a, _b;
        var sessionId;
        var ddCookie = document.cookie.split('; ').find(function (row) { return row.startsWith('_dd_s='); });
        if (ddCookie) {
            var cookieParams = new URLSearchParams(ddCookie.split('=')[1]);
            sessionId = cookieParams.get('id') || undefined;
        }
        if (!sessionId) {
            // @ts-expect-error DD_RUM is added to window by the Datadog RUM SDK
            sessionId = (_b = (_a = window.DD_RUM) === null || _a === void 0 ? void 0 : _a.getInternalContext()) === null || _b === void 0 ? void 0 : _b.session_id;
        }
        return sessionId;
    };
    Http.getHeaders = function (headers) {
        var shared = { 'Content-Type': 'application/json', 'x-datadog-session-id': this.getDDSessionId() };
        return headers ? __assign(__assign({}, shared), headers) : shared;
    };
    // response.json() fails when response body is empty so we need to handle that
    Http.getJsonResponse = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var json, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, response.json()];
                    case 1:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Http.prototype.getUrl = function (path, search) {
        if (!search) {
            return this.baseUrl.concat(path);
        }
        if (typeof search === 'string') {
            return this.baseUrl.concat(path).concat('?').concat(search);
        }
        var query = Object.keys(search)
            .map(function (key) {
            var value = search[key];
            if (Array.isArray(value)) {
                return "".concat(key, "=").concat(search[key].join(','));
            }
            return "".concat(key, "=").concat(search[key]);
        })
            .join('&');
        return this.baseUrl.concat(path).concat('?').concat(query);
    };
    Http.prototype.get = function (path, options) {
        return __awaiter(this, void 0, void 0, function () {
            var url, _a, meta, fetchOptions, optionsForRequest, response, dataOrError, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = this.getUrl(path, options === null || options === void 0 ? void 0 : options.search);
                        _a = options || {}, meta = _a.meta, fetchOptions = __rest(_a, ["meta"]);
                        optionsForRequest = __assign(__assign({}, (fetchOptions || {})), { headers: Http.getHeaders(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.headers) });
                        notifyRequestStart({
                            url: url,
                            method: 'GET',
                            meta: meta,
                        });
                        return [4 /*yield*/, fetch(url, optionsForRequest)];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, Http.getJsonResponse(response)];
                    case 2:
                        dataOrError = _b.sent();
                        if (!response.ok) {
                            error = Http.buildError(response, dataOrError);
                            notifyRequestError({
                                url: url,
                                error: error,
                                method: 'GET',
                                meta: meta,
                            });
                            throw error;
                        }
                        notifyRequestSuccess({
                            url: url,
                            method: 'GET',
                            meta: meta,
                        });
                        return [2 /*return*/, Http.buildResponse(dataOrError)];
                }
            });
        });
    };
    Http.prototype.request = function (method, path, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            var body, url, _a, meta, fetchOptions, headers, dataToSend_1, optionsForRequest, response, dataOrError, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = this.getUrl(path, options === null || options === void 0 ? void 0 : options.search);
                        _a = options || {}, meta = _a.meta, fetchOptions = __rest(_a, ["meta"]);
                        headers = Http.getHeaders(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.headers);
                        notifyRequestStart({
                            url: url,
                            method: method,
                            data: data,
                            meta: meta,
                        });
                        if (headers['Content-Type'] === 'multipart/form-data' && typeof data === 'object') {
                            dataToSend_1 = new FormData();
                            Object.entries(data).forEach(function (_a) {
                                var key = _a[0], value = _a[1];
                                var isEasilyAppendable = typeof value === 'string' || value instanceof File;
                                if (isEasilyAppendable) {
                                    dataToSend_1.append(key, value);
                                    return;
                                }
                                if (Array.isArray(value)) {
                                    value.forEach(function (valuePart) { return dataToSend_1.append("".concat(key, "[]"), valuePart); });
                                    return;
                                }
                                if (value instanceof FileList) {
                                    dataToSend_1.append(key, value[0]);
                                }
                            });
                            // Required, because otherwise we have to manually set the boundary
                            delete headers['Content-Type'];
                            body = dataToSend_1;
                        }
                        else {
                            body = JSON.stringify(data);
                        }
                        optionsForRequest = __assign(__assign({}, (fetchOptions || {})), { method: method, body: body, headers: headers });
                        return [4 /*yield*/, fetch(url, optionsForRequest)];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, Http.getJsonResponse(response)];
                    case 2:
                        dataOrError = _b.sent();
                        if (!response.ok) {
                            error = Http.buildError(response, dataOrError);
                            notifyRequestError({
                                url: url,
                                method: method,
                                data: data,
                                error: error,
                                meta: meta,
                            });
                            throw error;
                        }
                        notifyRequestSuccess({
                            url: url,
                            method: method,
                            data: data,
                            meta: meta,
                        });
                        return [2 /*return*/, Http.buildResponse(dataOrError)];
                }
            });
        });
    };
    Http.prototype.delete = function (path, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request('DELETE', path, data, options)];
            });
        });
    };
    Http.prototype.post = function (path, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request('POST', path, data, options)];
            });
        });
    };
    Http.prototype.put = function (path, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request('PUT', path, data, options)];
            });
        });
    };
    Http.prototype.patch = function (path, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request('PATCH', path, data, options)];
            });
        });
    };
    return Http;
}());
export { Http };
